import React from 'react'
import styled from '@emotion/styled'
import { Typography } from 'src/components/atoms/Typography'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'

const baseRed = '#ef5e4b'
const baseWhite = '#ffffff'

type Props = {
  className?: string
  text: string
  link: string
}

/**
 * バナーコンポーネント
 * バナーに表示したいメッセージを引数として渡す
 * 引数が渡されていないときはバナーは表示されません
 */
export const Banner: React.VFC<Props> = ({ className, text, link }) => {
  return (
    <Container>
      <BannerLink className={className} href={link} target="_blank">
        <BannerText>{text}</BannerText>
      {/*
        <Button>
          <ButtonText>
          <OnlyPC>今すぐ</OnlyPC>診断する
          </ButtonText>
        </Button>
      */}
      </BannerLink>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Styles.color.primary[400]};
  width: 100%;
  height: 60px;
  @media screen and (max-width: ${BreakPoint.TABLET}) {
    display: block;
  }
`

const BannerLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  @media screen and (max-width: ${BreakPoint.TABLET}) {
    justify-content: space-between;
  }
`

const BannerText = styled(Typography)`
  color: ${Styles.color.grayscale[100]};
  line-height: ${Styles.lineHeight[200]};
  font-weight: ${Styles.fontWeight.bold};
  flex: 1;
  min-width: 0;
  font-size: 15px;
  @media screen and (max-width: ${BreakPoint.TABLET}) {
    font-size: 13px;
    font-weight: ${Styles.fontWeight.normal};
  }
  @media screen and (max-width: ${BreakPoint.MOBILE}) {
    font-size: 11px;
  }
`

const Button = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${Styles.spacing[8]};
  @media screen and (max-width: ${BreakPoint.MOBILE}) {
    margin-left: ${Styles.spacing[6]};
  }
`

const ButtonText = styled(Typography)`
  color: ${baseWhite};
  font-size: 13px;
  line-height: 18px;
  font-weight: bold;
  background-color: #80A7E5;
  border-radius: ${Styles.borderRadius[1]};
  padding: ${Styles.spacing[4]} ${Styles.spacing[6]};
  cursor: pointer;
`

const OnlyPC = styled.span`
  @media screen and (max-width: ${BreakPoint.MOBILE}) {
    display: none;
  }
`